// TABLE_NAME: PlanesEstrategicosRevisionesComentariosTipos
export const CHANGE_REQUEST = 1;
export const APPROVED = 2;
